<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.change_practice_email.fields.email.change_email')"
                    :placeholder="$t('forms.change_practice_email.fields.email.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    type="email"
                    valuePath="email"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.change_practice_email.fields.email.confirm_email')"
                    :placeholder="$t('forms.change_practice_email.fields.email.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    :error="confirmEmailError"
                    type="email"
                    valuePath="confirmEmail"
                    @change="confirmEmailChange($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('forms.change_practice_email.buttons.cancel')"
                    :isSubmittable="false"
                    type="secondary"
                    @click="emitEvent({ name: 'cancel' })"
                ></common-button>
                <common-button :label="$t('forms.change_practice_email.buttons.save')" type="primary"></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                confirmEmailError: '',
            }
        },

        methods: {
            handleFormSubmission(data) {
                if (data.email !== data.confirmEmail) {
                    return (this.confirmEmailError = this.$t('forms.change_practice_email.not_matching'))
                }
                this.emitEvent({ name: 'success', payload: data.email })
            },

            confirmEmailChange(event) {
                this.confirmEmailError = ''
                this.change(event)
            },
        },
    }
</script>
